const PREFIX = 'mo-track-';

const buildEventName = (customName) => {
  return PREFIX + customName;
};

export const MO_TRACK_EVENTS = Object.freeze({
  BOOKED_ONE_ON_ONE: buildEventName('bookedOneOnOne'),
  BOOKED_AD_HOC_LESSON: buildEventName('bookedAdHocLesson'),
  BOOKED_CHALLENGE: buildEventName('bookedChallenge'),
  BOOKED_IWGT: buildEventName('bookedIWGT'),
  BOOKED_BUNDLE: buildEventName('bookedBundle'),
  BOOKED_CORE_ITEMS_IWGT: buildEventName('bookedCoreItemsIWGT'),
  CLICKED_DO_IT_WITH_CLASS: buildEventName('clickedDoItWithClass'),
  VIEWED_PERFORMANCE_CHART: buildEventName('viewedPerformanceChart'),
  SENT_BOOKING_REMINDER: buildEventName('sentBookingReminder'),
  CLICKED_PERFORMANCE_DETAILED_VIEW: buildEventName('clickedPerformanceDetailedView'),
  CLICKED_PERFORMANCE_GRID_VIEW: buildEventName('clickedPerformanceGridView'),
  CLICKED_TRANSLATION_PAGE_LINK: buildEventName('clickedTranslationPageLink'),
  GAVE_QUESTION_GROUP_FEEDBACK: buildEventName('gaveQuestionGroupFeedback'),
  GAVE_LESSON_FEEDBACK: buildEventName('gaveLessonFeedback'),
  GAVE_QUESTION_INDIVIDUAL_FEEDBACK_GRID_VIEW: buildEventName(
    'gaveQuestionIndividualFeedbackGridView'
  ),
  GAVE_QUESTION_INDIVIDUAL_FEEDBACK_DETAILED_VIEW: buildEventName(
    'gaveQuestionIndividualFeedbackDetailedView'
  ),
  CLICKED_BACK_TO_CLASS: buildEventName('clickedBackToClass'),
  CLICKED_STUDENT_LINK: buildEventName('clickedStudentLink'),
  CLICKED_BOOKING_PAGE_LINK: buildEventName('clickedOnBookingPageLink'),
  CLICKED_VIEW_DETAILS_ON_CLASS_PAGE: buildEventName('clickedViewDetailsOnClassPage'),
  CLICKED_LIBRARY_ITEM_HORIZONTAL: buildEventName('clickedLibraryItemHorizontal'),
  CLICKED_WEEKLY_POINTS_EDIT: buildEventName('clickedWeeklyPointsEdit'),
  CLICKED_PREVIEW_BOOKMARK_BUTTON: buildEventName('bookmark'),
  CLICKED_PREVIEW_REMOVE_BOOKMARK_BUTTON: buildEventName('removeBookmark'),
  CLICKED_CONTENT_EDIT_WARNING_LEARN_MORE_BUTTON: buildEventName(
    'clickedContentEditWarningLearnMore'
  ),
  CLICKED_CONTENT_EDIT_WARNING_OK_BUTTON: buildEventName('clickedContentEditWarningOk'),
  CLICKED_CONTENT_EDIT_WARNING_CANCEL_BUTTON: buildEventName('clickedContentEditWarningCancel'),
  CLICKED_UPCOMING_RECURRENT_LESSONS: buildEventName('clickedUpcomingRecurrentLessons'),
  CLICKED_PAST_RECURRENT_LESSONS: buildEventName('clickedPastRecurrentLessons'),
  CLICKED_VIEW_SUMMARY_RECURRENT_LESSONS: buildEventName('clickedViewSummaryRecurrentLessons'),
  CLICKED_RECURRENT_LESSONS_REQUEST_WIDGET: buildEventName('clickedRecurrentLessonsRequestWidget'),
  CLICKED_SORT_ON_RECURRENT_LESSONS_TABLE: buildEventName('clickedSortOnRecurrentLessonsTable'),
  CLICKED_WEEKLY_OOO_STUDENT_FILTER: buildEventName('clickedWeeklyOOOStudentFilter'),
  CLICKED_WEEKLY_OOO_SWITCH_CLASS: buildEventName('clickedWeeklyOOOSwitchClass'),
  CLICKED_WEEKLY_OOO_BACK_TO_CLASS: buildEventName('clickedWeeklyOOOBackToClass'),
  CLICKED_STUDENT_NAMES_ON_RECURRENT_LESSONS_TABLE: buildEventName(
    'clickedStudentNamesOnRecurrentLessonsTable'
  ),
  CLICKED_SHARE_TO_GOOGLE_CLASSROOM_BUTTON: buildEventName('clickedShareToGoogleClassroomButton'),
});

export const MO_TRACK_EVENTS_SESSION_USAGE = Object.freeze({
  CLICKED_TO_COMPLETION_RATE_LINK: buildEventName('clickedSessionUsageToCompletionRateLink'),
  CLICKED_BY_MONTH_CHART: buildEventName('clickedSessionUsageByMonthChart'),
  CLICKED_BY_CLASS_YEAR: buildEventName('clickedSessionUsageByClassYearChart'),
  CLICKED_BY_SCHOOL_CLASS: buildEventName('clickedSessionUsageBySchoolClassChart'),
  CLICKED_STAGE_SELECT: buildEventName('clickedSessionUsageStageSelect'),
  CLICKED_LEARNING_SUBJECT_SELECT: buildEventName('clickedSessionUsageLearningSubjectSelect'),
  CLICKED_SESSION_TYPES_SELECT: buildEventName('clickedSessionUsageSessionTypesSelect'),
  CLICKED_DATE_PRESET_SELECT: buildEventName('clickedSessionUsageDatePresetSelect'),
  CLICKED_DATE_RANGE_SELECT: buildEventName('clickedSessionUsageDateRangeSelect'),
  CLICKED_CHART_VIEW: buildEventName('clickedSessionUsageChartView'),
  CLICKED_TABLE_VIEW: buildEventName('clickedSessionUsageTableView'),
  CLICKED_INCLUDE_SSL: buildEventName('clickedSessionUsageIncludeSSL'),
  CLICKED_INCLUDE_ARCHIVED_CLASSES: buildEventName('clickedIncludeArchivedClasses'),
  CLICKED_CHART_SHOW_SESSION_TYPES_TOGGLE: buildEventName(
    'clickedSessionUsageChartShowSessionTypesToggle'
  ),
});

export const MO_TRACK_EVENTS_SESSION_COMPLETION_RATE = Object.freeze({
  CLICKED_TO_USAGE_LINK: buildEventName('clickedSessionCompletionRateToUsageLink'),
  CLICKED_BY_MONTH_CHART: buildEventName('clickedSessionCompletionRateByMonthChart'),
  CLICKED_BY_CLASS_YEAR: buildEventName('clickedSessionCompletionRateByClassYearChart'),
  CLICKED_BY_SCHOOL_CLASS: buildEventName('clickedSessionCompletionRateBySchoolClassChart'),
  CLICKED_INCLUDE_SSL: buildEventName('clickedSessionCompletionRateIncludeSSL'),
  CLICKED_STAGE_SELECT: buildEventName('clickedSessionCompletionRateStageSelect'),
  CLICKED_LEARNING_SUBJECT_SELECT: buildEventName(
    'clickedSessionCompletionRateLearningSubjectSelect'
  ),
  CLICKED_SESSION_TYPES_SELECT: buildEventName('clickedSessionCompletionRateSessionTypesSelect'),
  CLICKED_DATE_PRESET_SELECT: buildEventName('clickedSessionCompletionRateDatePresetSelect'),
  CLICKED_DATE_RANGE_SELECT: buildEventName('clickedSessionCompletionRateDateRangeSelect'),
  CLICKED_CHART_VIEW: buildEventName('clickedSessionCompletionRateChartView'),
  CLICKED_TABLE_VIEW: buildEventName('clickedSessionCompletionRateTableView'),
  CLICKED_CHART_SHOW_SESSION_TYPES_TOGGLE: buildEventName(
    'clickedSessionCompletionRateChartShowSessionTypesToggle'
  ),
  CLICKED_CHART_SHOW_NUMBERS_TOGGLE: buildEventName(
    'clickedSessionCompletionRateChartShowNumbersTypesToggle'
  ),
  CLICKED_INCLUDE_ARCHIVED_CLASSES: buildEventName('clickedIncludeArchivedClasses'),
});

export const MO_TRACK_EVENTS_AGGREGATED_PERFORMANCE = Object.freeze({
  CLICKED_SESSION_TYPES_SELECT: buildEventName('clickedAggregatedPerformanceSessionTypesSelect'),
  CLICKED_DATE_PRESET_SELECT: buildEventName('clickedAggregatedPerformanceDatePresetSelect'),
  CLICKED_DATE_RANGE_SELECT: buildEventName('clickedAggregatedPerformanceDateRangeSelect'),
  CLICKED_UNANSWERED_QUESTIONS_AS_INCORRECT_TOGGLE: buildEventName(
    'clickdAggregatedPerformanceUnansweredQuestionsAsIncorrectToggle'
  ),
  CLICKED_0_SESSIONS_LIBRARY_LINK: buildEventName(
    'clickedAggregatedPerformance0SessionsLibraryLink'
  ),
  CLICKED_SORT_BY_STUDENTS: buildEventName('clickedAggregatedPerformanceSortByStudents'),
  CLICKED_SORT_BY_OVERALL: buildEventName('clickedAggregatedPerformanceSortByOverall'),
  CLICKED_SORT_BY_CORRECT_ANS: buildEventName('clickedAggregatedPerformanceSortByCorrectAns'),
  CLICKED_SORT_BY_INCORRECT_ANS: buildEventName('clickedAggregatedPerformanceSortByIncorrectAns'),
  CLICKED_SORT_BY_GRADED_ANS: buildEventName('clickedAggregatedPerformanceSortByGradedAns'),
  CLICKED_SORT_BY_UNGRADED_ANS: buildEventName('clickedAggregatedPerformanceSortByUngradedAns'),
  CLICKED_SORT_BY_UNANSWERED_QUESTIONS: buildEventName(
    'clickedAggregatedPerformanceSortByUnansweredQuestions'
  ),
  CLICKED_SORT_BY_SESSIONS_COMPLETED: buildEventName(
    'clickedAggregatedPerformanceSortBySessionsCompleted'
  ),
  CLICKED_SORT_BY_SESSIONS_AVAILABLE: buildEventName(
    'clickedAggregatedPerformanceSortBySessionsAvailable'
  ),
  CLICKED_SWITCH_CLASS: buildEventName('clickedAggregatedPerformanceSwitchClass'),
});

export const MO_TRACK_EVENTS_STUDENT_ACTIVITIES = Object.freeze({
  CLICKED_SWITCH_CLASS: buildEventName('clickedStudentActivitiesSwitchClass'),
  CLICKED_LEARNING_ACTIONS_SELECT: buildEventName('clickedStudentActivitiesLearningActionsSelect'),
  CLICKED_DATE_PRESET_SELECT: buildEventName('clickedStudentActivitiesDatePresetSelect'),
  CLICKED_DATE_RANGE_SELECT: buildEventName('clickedStudentActivitiesDateRangeSelect'),
  CLICKED_BY_STUDENTS_CHART: buildEventName('clickedStudentActivitiesByStudentChart'),
  CLICKED_BY_WEEK_CHART: buildEventName('clickedStudentActivitiesByWeekChart'),
  CLICKED_BY_DAY_CHART: buildEventName('clickedStudentActivitiesByDayChart'),
  CLICKED_SHOW_ACTIONS_TOGGLE: buildEventName('clickedStudentActivitiesShowActionsToggle'),
  CLICKED_SHOW_FUTURE_DATES_TOGGLE: buildEventName('clickedStudentActivitiesShowFutureDatesToggle'),
  CLICKED_SHOW_DAYS_OF_MONTH_TOGGLE: buildEventName(
    'clickedStudentActivitiesShowDaysOfMonthToggle'
  ),
});

export const MO_TRACK_EVENTS_LIBRARY = Object.freeze({
  TAB_ALL_SESSIONS: buildEventName('clickedLibraryTabAllSessions'),
  TAB_FAVORITES: buildEventName('clickedLibraryTabFavorites'),
  TAB_CREATED_FOR_SCHOOL: buildEventName('clickedLibraryTabCreatedForSchool'),
  TAB_PREVIOUSLY_BOOKED: buildEventName('clickedLibraryTabPreviouslyBooked'),
  TAB_BOOKED_BY_OTHER_TEACHERS: buildEventName('clickedLibraryTabBookedByOtherTeachers'),
  TAB_BUNDLES: buildEventName('clickedLibraryTabBundles'),
  TAB_WITH_PRACTICE_BUDDY: buildEventName('clickedLibraryTabWithPracticeBuddy'),
  CLEAR_FILTER_ITEM: buildEventName('clickedClearFilterItem'),
  CLEAR_FILTER_ALL: buildEventName('clickedClearFilterAll'),
  TOPICS_FILTER: buildEventName('clickedTopicsFilter'),
  LEVELS_FILTER: buildEventName('clickedLevelsFilter'),
});

export const MO_TRACK_EVENTS_BUNDLE = Object.freeze({
  CLICKED_BUNDLE_MATERIAL_CARD: buildEventName('clickedBundleMaterialCard'),
  CLICKED_ADD_SESSIONS_FROM_LIBRARY: buildEventName('clickedAddSessionsInBundle'),
  CLICKED_BACK_IN_STEP_ONE: buildEventName('clickedBackInStepOneBundle'),
  CLICKED_NEXT_IN_STEP_ONE: buildEventName('clickedNextInStepOneBundle'),
  CLICKED_REARRANGE_MATERIAL: buildEventName('clickedRearrangeMaterialInBundle'),
  CLICKED_REMOVE_MATERIAL: buildEventName('clickedRemoveMaterialInBundle'),
  CLICKED_RELEASE_ON_SAME_DATE: buildEventName('clickedReleaseOnSameDateInBundle'),
  CLICKED_RELEASE_DAILY: buildEventName('clickedReleaseDailyInBundle'),
  CLICKED_RELEASE_WEEKLY: buildEventName('clickedReleaseWeeklyInBundle'),
  CLICKED_EDIT_START_DATE: buildEventName('clickedEditStartDateInBundle'),
  CLICKED_EDIT_END_DATE: buildEventName('clickedEditEndDateInBundle'),
  CLICKED_ADVANCED_SETTINGS: buildEventName('clickedAdvancedSettingsInBundle'),
  CLICKED_BACK_IN_STEP_TWO: buildEventName('clickedBackInStepTwoBundle'),
  CLICKED_DONE_IN_SUCCESS_MODAL: buildEventName('clickedDoneInBundleSuccessModal'),
  CLICKED_BUNDLE_FROM_SIDEBAR: buildEventName('clickBundleFromSidebar'),
  CLICKED_BUNDLE_FROM_RECOMMENDED: buildEventName('clickedBundleFromRecommended'),
  CLICKED_EXPLORE_MORE_BUNDLES: buildEventName('clickedExploreMoreBundles'),
  CLICKED_CARD_IN_RECOMMENDED_BUNDLES: buildEventName('clickedCardInRecommendedBundles'),
  CLICKED_BOOK_BUNDLE_IN_BUNDLES_PAGE: buildEventName('clickedBookBundleInBundlesPage'),
});

export const MO_TRACK_CLASS_WEEKLY_PERFORMANCE = Object.freeze({
  CLICKED_EXIT_PROJECTOR_MODE: buildEventName('clickedExitProjectorModeInClassWeeklyPerformance'),
  CLICKED_END_PRESENTATION: buildEventName('clickedEndPresentationInClassWeeklyPerformance'),
});

export const MO_TRACK_EVENTS_SESSION_DETAILS = Object.freeze({
  CLICK_SEND_REMINDER: 'click send reminder',
  CLICK_DO_IT_WITH_CLASS: 'click do it with class',
  EDIT_DEADLINE: 'edit deadline',
  EDIT_START_DATE: 'edit start date',
  CLICK_CANCEL_SESSION: 'click cancel session',
  CONFIRM_CANCEL_SESSION: 'confirm cancel session',
  CANCEL_SESSION: 'cancel session',
  VIEW_SESSION_PERFORMANCE_CHART: 'view session performance chart',
  REMOVE_STUDENTS_FROM_SESSION: 'remove students from session',
  ADD_STUDENTS_TO_SESSION: 'add students to session',
  GENERATE_SESSION_CODE: 'generate session code',
  COPY_SESSION_CODE: 'copy session code',
  // NEW SESSION DETAILS PAGE
  SWITCH_TO_OLD_SESSION_DETAILS: 'switch to old session details',
  SWITCH_TO_NEW_SESSION_DETAILS: 'switch to new session details',
  SWITCH_INSIGHTS_TAB: 'switch insights tab',
  CLICK_INSIGHTS_ITEM: 'click insights item',
  CLICK_SHOW_STUDENT_ANSWERS: 'click show student answers',
  CLICK_SHOW_MC_STUDENT_ANSWERS: 'click show mc student answers',
  CLICK_CLASS_PERFORMANCE: buildEventName('clickClassPerformance'),
  CLICK_CLASS_PERFORMANCE_STRENGTHS: buildEventName('clickClassPerformanceStrengths'),
  CLICK_STUDENT_PERFORMANCE: buildEventName('clickStudentPerformance'),
});

export const MO_TRACK_EVENTS_CLASS_PAGE = Object.freeze({
  VIEW_CLASS_TO_CLASS_POINTS_SLIDE: 'view class to class points slide',
  VIEW_CURRENT_WEEK_POINTS_SLIDE: 'view current week points slide',
  VIEW_NEXT_AVATAR_SLIDE: 'view next avatar slide',
  VIEW_TOP_FIVE_CONTRIBUTORS_SLIDE: 'view top five contributors slide',
  VIEW_POINTS_TRENDING_SLIDE: 'view points trending slide',
  VIEW_CLASS_POINTS_BUTTON: 'view class points button',
  EDIT_WEEKLY_GOAL: 'edit weekly goal',
  SAVE_WEEKLY_GOAL: 'save weekly goal',
  START_EXERCISE_IN_LESSON_PLANNER: buildEventName('startExerciseInLessonPlanner'),
  CLICK_INSIGHTS_IN_LESSON_PLANNER: buildEventName('clickInsightsInLessonPlanner'),
  LIVE_REPORT_TABLE: buildEventName('clickLiveReportTable'),
});

export const MO_TRACK_EVENTS_IN_CLASS_LEADERBOARD = Object.freeze({
  OPEN_IN_CLASS_LEADERBOARD: 'open in class leaderboard',
  EXIT_FULLSCREEN_MODE: 'clicked in class leaderboard exit fullscreen mode',
  VIEW_WEEKLY_POINTS_TAB: 'in class leaderboard view weekly points tab',
  VIEW_TOP_FIVE_STUDENTS_TAB: 'in class leaderboard view top five students tab',
  VIEW_CLASS_TO_CLASS_LEADERBOARD_TAB: 'in class leaderboard view class to class leaderboard tab',
  VIEW_CLASS_PROGRESS_TAB: 'in class leaderboard view class progress tab',
  VIEW_AVATARS_TAB: 'in class leaderboard view avatars tab',
});

export const MO_TRACK_EVENTS_ACCOUNT = Object.freeze({
  UPDATE_PROFILE_PICTURE: 'update profile picture',
  FORGOT_PASSWORD: 'forgot password',
  CHANGE_PASSWORD: 'change password',
  SUBMIT_NEW_PASSWORD: 'submit new password',
  SUBMIT_LOGIN_FORM: 'submit login form',
  LOGIN_SUCCESS: 'login success',
  LOGIN_FAILED: 'login failed',
});

export const MO_TRACK_EVENTS_WEEKLY_OOO = Object.freeze({
  REQUEST_WEEKLY_OOO_BOOKING: 'request weekly 1-1 booking',
  APPROVE_WEEKLY_OOO_BOOKING: 'approve weekly 1-1 booking',
  DECLINE_WEEKLY_OOO_BOOKING: 'decline weekly 1-1 booking',
});

export const MO_TRACK_EVENTS_LESSON_PLANS = Object.freeze({
  CLICKED_START_NOW_BUTTON: 'click lesson plan start now',
  CLICKED_INSIGHTS_BUTTON: 'click lesson plan insights button',
});

export const MO_TRACK_EVENTS_ERROR = Object.freeze({
  PAGE_CRASH: 'page crash',
});

export const MO_TRACK_EVENTS_HOMEPAGE = Object.freeze({
  ADD_NEW_CLASSES_BUTTONS: buildEventName('addNewClassesButtons'),
});

export const MO_TRACK_EVENTS_ORGANIZATION_MENU = Object.freeze({
  CLICK_CLASSES_MENU_ITEM: buildEventName('clickClassesMenuItem'),
  CLICK_STUDENTS_MENU_ITEM: buildEventName('clickStudentsMenuItem'),
  CLICK_LIBRARY_MENU_ITEM: buildEventName('clickLibraryMenuItem'),
  CLICK_MEEOPP_TRIVIA_MENU_ITEM: buildEventName('clickMeeoppTriviaMenuItem'),
  CLICK_HELP_CENTER_MENU_ITEM: buildEventName('clickHelpCenterMenuItem'),
  CLICK_MY_EXERCISES_MENU_ITEM: buildEventName('clickMyExercisesMenuItem'),
});
